module.exports = __webpack_public_path__ + "img/globe.26f2f492.svg";